<template>
  <div></div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import {
  qFetchHouse,
  qFetchBrandHouse,
  QFetchFaviroteList,
  QFetchFavirote,
  qSearchHouse,
  qFetchHouseNew
} from '@/services/q_house'
import { Sniff } from '@/utils/q_sniff'
import { loginQ } from '@/utils/q_userinfo'
import { getStorge, saveStorge, localKeys, getFromForLog, throttle, RouterHelper, openScheme } from '@/utils/q_business'
import sendLog from '@/utils/q_log'
import { eventBusV } from '@/utils/q_hook'
import { getLinks } from '@/utils/linkUtil'
import qunarRedirect from '@/utils/qunarRedirect'
const ONE_DAY = 1000 * 60 * 60 * 24 // 一天的时间戳
export default {
  mixins: [qunarRedirect],
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      fromDate: '',
      toDate: ''
    }
  },
  computed: {
    ...mapState(['houseFilter']),
    filterCondition() {
      return this.houseFilter.checkInDate + this.houseFilter.checkOutDate + this.houseFilter.onlyCanBooking + this.houseFilter.cityId
    }
  },
  watch: {
    payLoad(newVal) {
      // eslint-disable-next-line
      if (newVal && newVal.type === 'openHouseInfo') {
        const logParam = {
          actPos: `${this.compIndex}_${newVal.houseIndex}_1`,
          actPage: `cms_${this.$root.promotionId}`,
          actText: `cms_${this.$root.promotionId}_houseCard`,
          actInfo: {houseId: newVal.data}
        }
        sendLog(logParam)

        this.showHouseInfo(newVal.data, newVal.checkInDate, newVal.checkOutDate)
      } else if (newVal && newVal.type === 'favoriteHouse') {
        loginQ().then(() => {
          const logParam = {
            actPos: `${this.compIndex}_${newVal.data.houseIndex}_0`,
            actPage: `cms_${this.$root.promotionId}`,
            actText: `cms_${this.$root.promotionId}_favoriteBtn`,
            actInfo: {houseId: newVal.data}
          }
          sendLog(logParam)
          this.doFavorite(newVal.data)
        }).catch((err) => { console.log(err) })
      }
    },
    filterCondition(newV, oldV) {
      if (newV !== oldV) {
        // 非专属房源
        if (this.compProps.houseChoice !== '3') {
          this.initHouses()
        }
      }
    }
  },
  async mounted() {
    this.initHouses()
  },
  methods: {
    /**
     * 跳转房屋详情
     * @param {Number} unitId 房屋id
     */
    showHouseInfo(unitId, startDate, endDate) {
      const PAGE_DETAIL = 'detail'
      const fromForLog = getFromForLog()
      const houseID = unitId
      let params = {
        fromForLog,
        houseID,
        fromDate: startDate,
        toDate: endDate
      }
      // const url = RouterHelper(PAGE_DETAIL, params)
      // const _openScheme = throttle(this.openScheme, 800)
      // _openScheme(url, unitId, startDate, endDate)
      const links = getLinks('detail', {
        houseId: params.houseID,
        checkInDate: params.fromDate,
        checkOutDate: params.toDate,
        channelId: fromForLog
      })
      this.redirectTo({
        mpLink: links.mpUrl,
        appLink:
          `react/open?hybridId=tj_order_qtaro_rn&pageName=DetailPageTaro&initProps=${encodeURIComponent(
            JSON.stringify({
              param: {
                houseId: params.houseID,
                checkInDate: params.fromDate,
                checkOutDate: params.toDate,
                channelId: fromForLog,
              },
            }),
          )}` || links.qAPPUrl,
        activeLink: links.webUrl
      })
    },
    /**
     * 收藏
     * @param {Object} house 房屋
     */
    async doFavorite(house) {
      const res = await QFetchFavirote(house,this.fromDate,this.toDate)
      const collectMap = getStorge(localKeys.HOUSE_COLLECTION) || {}
      const houseID = house.id
      if (res.ret) {
        if (house.isLike) {
          collectMap && collectMap[houseID] && delete collectMap[houseID]
          saveStorge(localKeys.HOUSE_COLLECTION, collectMap)
        } else {
          collectMap[houseID] = true
          saveStorge(localKeys.HOUSE_COLLECTION, collectMap)
        }
        this.$emit('finish', {
          type: 'favirote',
          data: { id: house.id, isLike: !house.isLike }
        })
      }
    },
    // openScheme(url, unitId, startDate, endDate) {
    //   const { fromForLog, code = `cms_${this.$root.promotionId}` } = this.$route.query
    //   if (Sniff.miniprogram) {
    //     openScheme(`https://m.tujia.com/detail/${unitId}.htm?beginDate=${startDate}&endDate=${endDate}&code=${fromForLog||code}`)
    //     return
    //   }
    //   if (Sniff.qunar) {
    //     const { scheme, isRN } = Sniff;
    //     const params = {
    //       param: {
    //         houseId: unitId,
    //         checkin: startDate,
    //         checkout: endDate
    //       }
    //     }
    //     window.location.href = `${scheme}://react/open?hybridId=tj_product_detail_rn&pageName=ProductPage&channelId=${fromForLog||code}&initProps=${encodeURIComponent(JSON.stringify(params))}`
    //     // 之前这里判断 isRN  如果是RN跳转RN页面， 否则跳转原生  现在获取isRN是false导致跳转到原生页面（原生页面不维护了）
    //     // 现在全部跳转RN页面
    //     // const hysdk = window.hysdk
    //     // hysdk && hysdk.openWebView({ url, type: 'navibar-none' })
    //     return
    //   }
    //   const scheme = Sniff.ios ? 'qunariphone' : 'qunaraphone'
    //   const schemeUrl = `${scheme}://hy?url=${encodeURIComponent( url )}&type=navibar-none`
    //   window.location.href = schemeUrl
    //   window.setTimeout(() => { window.location.href = url }, 500)
    // },
    /**
     * 初始化房屋信息
     */
    async initHouses() {
      let ret = null
      const ids = []
      const { cityId = '' } = this.$route.query
      const aIds = (this.compProps.promotionId && this.compProps.promotionId.split(',')) || []
      const maxShowNumber = this.compProps.maxShowNumber
      let noHavePriceHouse = {}
      // 0表示房屋id 1表示是商户id查询房屋 2表示搜索接口 3专属房源
      if (this.compProps.houseChoice === '1') {
        let landlordIds = []
        this.compProps.landlordIds && this.compProps.landlordIds.split(',').forEach((element) => {
          landlordIds.push(+element)
        })
        let params = {
          parameter: {
            cityId: cityId,
            landlordIds: landlordIds || [],
            defaultBetweenDays: +this.compProps.priceTime,
            pagesize: +maxShowNumber,
            pageIndex: +this.compProps.pageIndex || 1,
            needNoRepositoty: this.compProps.needNoRepositoty,
          }
        }
        const houseData = await qFetchBrandHouse(params)
        ret = houseData.value || {}
      } else if (this.compProps.houseChoice === '0') {
        this.compProps.houses.forEach((house) => {
          ids.push(house.id)
        })
        // 有筛选栏时，不可订房屋
        const notOrderableFilter = this.houseFilter.visible && !this.houseFilter.onlyCanBooking && this.compProps.needNoRepositoty
        // 无筛选栏时，不可订房屋
        const notOrderable = !this.houseFilter.visible && this.compProps.needNoRepositoty
        /**
         * TOC-5607 H5配置后台功能增强一期C - 房屋列表增加选项
         * 城市是否收全局城市控制，因为线上是默认受控的，为了保持线上一致
         * 所以 isCityControl 为 false， 为不受控
         * 其他值都为受控
         */
        const needCityId = (this.compProps.isCityControl === false? '': this.houseFilter.cityId) || cityId
        const params = {
          parameter: {
            houseIdList: this.compProps.isOutOfOrder ? this.changeSort(ids) : ids,
            defaultBetweenDays: this.compProps.priceTime || 1,
            activityIds: aIds,
            houseCardType: this.compProps.mode,
            needNoRepositoty: this.houseFilter.visible ? !this.houseFilter.onlyCanBooking : this.compProps.needNoRepositoty,
            pageSize: maxShowNumber,
            checkInDate: this.houseFilter.checkInDate,
            checkOutDate: this.houseFilter.checkOutDate,
            onlyCanBooking: this.houseFilter.visible && this.houseFilter.onlyCanBooking,
            noNeedPrice: false,
            cityId: needCityId
          }
        }
        let houseData = {}
        if (notOrderableFilter || notOrderable) { //不可订
          houseData = await this.qFetchHouseHandle(params)
          let havePriceData = houseData.value
          if (havePriceData && havePriceData.data && havePriceData.data.items) {
            if (havePriceData.data.items.length !== ids.length) {
              params.parameter.noNeedPrice = true
              noHavePriceHouse = await this.qFetchHouseHandle(params)
              let noHavePriceData = noHavePriceHouse.value
              if (noHavePriceData && noHavePriceData.data && noHavePriceData.data.items) {
                let allArr = noHavePriceData.data.items.map((noPrice) => 
                    havePriceData.data.items.find((havePrice) => havePrice.unitId === noPrice.unitId) || noPrice
                )
                havePriceData.data.items = [...allArr]
                havePriceData.data.totalCount = noHavePriceData.data.totalCount
              }
            }
          }
        } else {
          houseData = await this.qFetchHouseHandle(params)
        }
        ret = houseData.value || {}
      } else if (this.compProps.houseChoice === '2') {
        // 存cookie，用于node的搜索接口，访客模式也出价格
        if (!Cookies.get('mkt_flag') && Cookies.get('_visitor_flag') === 'visitor000000') {
          Cookies.set('mkt_flag', true)
        }
        const params = {
          parameter: {
            pageIndex: 0,
            pageSize: maxShowNumber,
            conditions: []
          }
        }
        /**
         * TOC-5607 H5配置后台功能增强一期C - 房屋列表增加选项
         * 城市是否收全局城市控制，因为线上是默认受控的，为了保持线上一致
         * 所以 isCityControl 为 false， 为不受控
         * 其他值都为受控
         */
        const needCityId = this.compProps.isCityControl === false? '': this.houseFilter.cityId
        // 城市，字符串
        params.parameter.conditions.push({ type: 1, value: String(needCityId || this.compProps.searchCityId || '8')})
        // 入离
        let checkInDate = this.houseFilter.checkInDate
        let checkOutDate = this.houseFilter.checkOutDate
        if ((!this.houseFilter.checkInDate || !this.houseFilter.checkOutDate) && Number(this.compProps.priceTime) > 1) {
          let moment = require('moment')
          checkInDate = moment().add('days', Number(this.compProps.priceTime) - 1).format('YYYY-MM-DD')
          checkOutDate = moment().add('days', Number(this.compProps.priceTime)).format('YYYY-MM-DD')
        }
        checkInDate ? params.parameter.conditions.push({ type: 2, value: checkInDate }) : null
        checkOutDate ? params.parameter.conditions.push({ type: 3, value: checkOutDate }) : null
        // 价格
        this.compProps.minPrice || this.compProps.maxPrice ? params.parameter.conditions.push({ type: 7, value: `${this.compProps.minPrice || 0},${this.compProps.maxPrice || 100000}` }) : null
        // 筛选项
        const labelIds = this.compProps.labelIds && this.compProps.labelIds.split(',') || []
        labelIds.forEach((item) => {
          item && params.parameter.conditions.push({ type: 6, value: String(item) })
        })
        const houseData = await qSearchHouse(params)
        ret = houseData.value || {}
        if (ret && ret.errcode === 0) {
          const data = ret.data || {}
          data.items && data.items.forEach((item) => {
            // 是否可定
            item.allowBooking = item.failType === 0
            if (!item.priceTags || item.priceTags.length === 0) {
              const priceTagText = item.priceTagVO?.totalReduceAmount || item.priceTipBadge?.text || ''
              if (priceTagText) {
                item.priceTags = [{ text: priceTagText }]
              }
            }
          })
        } else {
          this.$toast('请求有误，请稍后重试')
        }
      } else if (this.compProps.houseChoice === '3') {
        // 专属房源
        this.compProps.houses.forEach((house) => {
          ids.push(house.id)
        })
        const checkInDate = this.$route?.query?.priceCheckInDate || null
        const checkOutDate = this.$route?.query?.priceCheckOutDate || null
        const params = {
          parameter: {
            houseIdList: ids,
            defaultBetweenDays: this.compProps.priceTime || 1,
            activityIds: aIds,
            houseCardType: this.compProps.mode,
            needNoRepositoty: true,
            pageSize: maxShowNumber,
            checkInDate: checkInDate,
            checkOutDate: checkOutDate,
            onlyCanBooking: false,
            noNeedPrice: false
          }
        }
        let houseData = {}
        houseData = await this.qFetchHouseHandle(params)
        let havePriceData = houseData.value || {}
        if ((havePriceData.data && havePriceData.data.items && havePriceData.data.items.length !== ids.length) || !havePriceData.data) {
          params.parameter.noNeedPrice = true
          noHavePriceHouse = await this.qFetchHouseHandle(params)
          let noHavePriceData = noHavePriceHouse.value || {}
          if (noHavePriceData.data && noHavePriceData.data.items) {
            let allArr = noHavePriceData.data.items.map((noPrice) => 
                havePriceData.data?.items?.find((havePrice) => havePrice.unitId === noPrice.unitId) || noPrice
            )
            havePriceData.data.items = allArr ? [...allArr] : []
            havePriceData.data.totalCount = noHavePriceData.data.totalCount || 0
          }
        }
        ret = houseData.value || {}
        eventBusV.$emit('exclusiveHouse', ret.data?.items?.[0] || {})
      }
      const faviroteIds = await QFetchFaviroteList()
      let total = (ret.data && ret.data.totalCount) || 0
      let items = (ret.data && ret.data.items) || []
      if (total > maxShowNumber) {
        total = maxShowNumber
        items = items && items.splice(0, total)
      }
      let hasPriceTags = false
      let hasSpecialTags = false
      items = items && items.map((item) => {
        let house = item
        if (this.compProps.houseChoice === '0') {
          house = this.compProps.houses.find((itemHouse) => {
            return itemHouse.id + '' === item.unitId + ''
          })
        }
        const favirote = faviroteIds.find((faviroteId) => {
          return faviroteId + '' === item.unitId + ''
        })
        let priceTags = item.priceTags || []
        if (priceTags && priceTags.length > 0) {
          hasPriceTags = true
        }
        let specialTags = item.specialTags || []
        if (specialTags.length > 0) {
          hasSpecialTags = true
        }
        return {
          ...item,
          priceTags,
          comment: house.comment,
          houseLabels: house.labels,
          isLike: favirote !== undefined
        }
      })
      items = items && items.map((item) => {
        return {
          ...item,
          hasPriceTags,
          hasSpecialTags
        }
      })
      const data = {
        totalCount: total,
        items: items || []
      }
      eventBusV.$emit('houseSet', data)
      this.$emit('init', {
        totalCount: total,
        items: items
      })
    },
    changeSort(arr) {
      if(!arr) {
        return []
      }
      let array = JSON.parse(JSON.stringify(arr))
      let j, x, i
      for (i = array.length; i; i--) {
        j = Math.floor(Math.random() * i)
        x = array[i - 1]
        array[i - 1] = array[j]
        array[j] = x
      }
      return array
    },
    async qFetchHouseHandle() {
      return this.$root.isFetchHouseNewForCMS ? qFetchHouseNew(...arguments) : qFetchHouse(...arguments)
    }
  }
}
</script>
